export default [
  {
    path: 'proveedores',
    component: () => import('@/components/shared/proveedores/ProveedoresIndex.vue'),
    props: { baseRoute: 'empresa' },
    children: [
      {
        path: '', // Ruta base: /proveedores
        name: 'empresa.proveedores',
        component: () => import('@/components/shared/proveedores/ProveedoresList.vue'),
      },
      {
        path: 'nuevo', // Ruta: /proveedores/nuevo
        name: 'empresa.proveedores.create',
        component: () => import('@/components/shared/proveedores/componentes/ProveedorCreate.vue'),
      },
      {
        path: 'listas-de-precio',
        component: () => import('@/components/shared/proveedores/listasprecio/ListasPrecioLayout.vue'),
        children: [
          {
            path: '',
            name: 'empresa.proveedores.listasdeprecio',
            component: () => import('@/components/shared/proveedores/listasprecio/ListasPrecioMonitor.vue'),
          },
          {
            path: 'comparativa',
            name: 'empresa.proveedores.comparativa',
            component: () => import('@/components/shared/proveedores/listasprecio/ListasPrecioComparar.vue'),
          }
        ]
      }

    ]
  },

  {
    path: 'proveedores/:id_proveedor',
    component: () => import('@/components/shared/proveedores/ProveedorLayout.vue'),
    props: { baseRoute: 'empresa' },
    // Rutas hijas paso baseRoute mediante router-view
    children: [
      {
        path: '',
        name: 'empresa.proveedor.profile',
        component: () => import('@/components/shared/proveedores/ProveedorProfile.vue'),
      },
      {
        path: 'editar',
        name: 'empresa.proveedor.update',
        component: () => import('@/components/shared/proveedores/ProveedorUpdate.vue'),
      },
      {
        path: 'listadeprecios',
        name: 'empresa.proveedor.listadeprecios',
        component: () => import('@/components/shared/proveedores/ProveedorListaDePrecio.vue'),
      },
      {
        path: 'cuenta-corriente',
        name: 'empresa.proveedor.cuentacorriente',
        component: () => import('@/components/shared/proveedores/ProveedorCuentaCorriente.vue'),
      },
    ],
  },
];
